export const levelOptions = [
  { label: "Level 2" },
  { label: "Level 3" },
];

export const booleanOptions = [
  { id: 1, label: "Yes" },
  { id: 2, label: "No" },
  { id: 3, label: "Not Applicable" },
];

export const inspectionservicesTable = [
  {
    field: "id",
    headerName: "Sr.No.",
  },
  {
    field: "inspectionservicesTable",
    headerName: "Inspection Items",
  },
  {
    field: "quantity",
    headerName: "Quantity",
  },  
];

export const BGASNACEoption = [
  { id: 1, label: "BGAS" },
  { id: 2, label: "NACE" },
];

export const APIqualificationEoption = [
  { id: 1, label: "510" },
  { id: 2, label: "570" },
  { id: 3, label: "580" },
  { id: 4, label: "650" },
  { id: 5, label: "581" },
  { id: 6, label: "936" },
];

export const WeldingqualificationEoption = [
  { id: 1, label: "CSWIP 3.1" },
  { id: 2, label: "CSWIP 3.2" },
  { id: 3, label: "AWS" },
  { id: 4, label: "ISNT" },
  { id: 5, label: "IWE" },
];

export const qmsAuditor = [
  { id: 1, label: "ISO 9001" },
  { id: 2, label: "ISO 14001" },
  { id: 3, label: "ISO 45001" },
  { id: 4, label: "ISO 17020" },
  { id: 5, label: "Internal auditor" },
];


